var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdaptedBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.862,
    height: 19.836,
    viewBox: "0 0 20.862 19.836",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#009cca;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(79.115 -2977.932)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M264.93,3326.517l-1.637-2.845.286-.166a.239.239,0,0,0,.008-.408l-1.917-1.219a.238.238,0,0,0-.366.212l.106,2.27a.239.239,0,0,0,.358.2l.2-.118,1.229,2.136-6.435-.009a.764.764,0,1,0,0,1.528l7.248.009A1.059,1.059,0,0,0,264.93,3326.517Z",
    transform: "translate(-323.325 -331.811)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-73.02,3305.249h-1.872a.348.348,0,0,0-.348.348v.208l-1.941,0,2.488-4.3a.764.764,0,0,0-.3-1.057l-.045-.024a.764.764,0,0,0-1.021.292l-2.909,5.022a1.059,1.059,0,0,0,.915,1.59l2.815,0v.136a.348.348,0,0,0,.348.348h1.872a.348.348,0,0,0,.348-.348V3305.6A.348.348,0,0,0-73.02,3305.249Z",
    transform: "translate(0 -311.061)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M131.7,3416.386l-3.1-1.845a.394.394,0,0,0-.6.339v3.688a.394.394,0,0,0,.6.339l3.1-1.844A.394.394,0,0,0,131.7,3416.386Z",
    transform: "translate(-199.828 -421.195)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 2.093,
    cy: 2.093,
    r: 2.093,
    transform: "translate(-65.32 2985.675)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M105.249,2984.514a1.249,1.249,0,0,0,1.158-1.716l1.631-2.817,2.867,4.98a.764.764,0,0,0,1.046.28h0a.764.764,0,0,0,.279-1.042l-3.3-5.735a1.059,1.059,0,0,0-1.835,0l-2.071,3.575a1.249,1.249,0,0,0,.226,2.477Z",
    transform: "translate(-176.672 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.362,3161.117l-2.816-1.625a.314.314,0,0,0-.429.115l-1.626,2.816a.314.314,0,0,0,.115.429l2.816,1.626a.314.314,0,0,0,.429-.115l1.626-2.816A.314.314,0,0,0,13.362,3161.117Z",
    transform: "translate(-84.483 -175.131)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdaptedBlue);
export default __webpack_public_path__ + "static/media/adapted-blue.be4bea20040ad1f103cf1e6444e12eb7.svg";
export { ForwardRef as ReactComponent };